var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedStatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_142_191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_142_191)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.33333,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_142_191)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66668 2.00004C2.66668 2.36823 2.3682 2.66671 2.00001 2.66671C1.63182 2.66671 1.33334 2.36823 1.33334 2.00004C1.33334 1.63185 1.63182 1.33337 2.00001 1.33337C2.3682 1.33337 2.66668 1.63185 2.66668 2.00004ZM5.33334 2.00004C5.33334 2.36823 5.03487 2.66671 4.66668 2.66671C4.29849 2.66671 4.00001 2.36823 4.00001 2.00004C4.00001 1.63185 4.29849 1.33337 4.66668 1.33337C5.03487 1.33337 5.33334 1.63185 5.33334 2.00004ZM7.33334 2.66671C7.70153 2.66671 8.00001 2.36823 8.00001 2.00004C8.00001 1.63185 7.70153 1.33337 7.33334 1.33337C6.96515 1.33337 6.66668 1.63185 6.66668 2.00004C6.66668 2.36823 6.96515 2.66671 7.33334 2.66671ZM10.6667 2.00004C10.6667 2.36823 10.3682 2.66671 10 2.66671C9.63182 2.66671 9.33334 2.36823 9.33334 2.00004C9.33334 1.63185 9.63182 1.33337 10 1.33337C10.3682 1.33337 10.6667 1.63185 10.6667 2.00004ZM3.33334 4.00004C3.70153 4.00004 4.00001 3.70156 4.00001 3.33337C4.00001 2.96518 3.70153 2.66671 3.33334 2.66671C2.96515 2.66671 2.66668 2.96518 2.66668 3.33337C2.66668 3.70156 2.96515 4.00004 3.33334 4.00004ZM6.66668 3.33337C6.66668 3.70156 6.3682 4.00004 6.00001 4.00004C5.63182 4.00004 5.33334 3.70156 5.33334 3.33337C5.33334 2.96518 5.63182 2.66671 6.00001 2.66671C6.3682 2.66671 6.66668 2.96518 6.66668 3.33337ZM8.66668 4.00004C9.03487 4.00004 9.33334 3.70156 9.33334 3.33337C9.33334 2.96518 9.03487 2.66671 8.66668 2.66671C8.29849 2.66671 8.00001 2.96518 8.00001 3.33337C8.00001 3.70156 8.29849 4.00004 8.66668 4.00004ZM10.6667 4.66671C10.6667 5.0349 10.3682 5.33337 10 5.33337C9.63182 5.33337 9.33334 5.0349 9.33334 4.66671C9.33334 4.29852 9.63182 4.00004 10 4.00004C10.3682 4.00004 10.6667 4.29852 10.6667 4.66671ZM7.33334 5.33337C7.70153 5.33337 8.00001 5.0349 8.00001 4.66671C8.00001 4.29852 7.70153 4.00004 7.33334 4.00004C6.96515 4.00004 6.66668 4.29852 6.66668 4.66671C6.66668 5.0349 6.96515 5.33337 7.33334 5.33337ZM5.33334 4.66671C5.33334 5.0349 5.03487 5.33337 4.66668 5.33337C4.29849 5.33337 4.00001 5.0349 4.00001 4.66671C4.00001 4.29852 4.29849 4.00004 4.66668 4.00004C5.03487 4.00004 5.33334 4.29852 5.33334 4.66671ZM2.00001 5.33337C2.3682 5.33337 2.66668 5.0349 2.66668 4.66671C2.66668 4.29852 2.3682 4.00004 2.00001 4.00004C1.63182 4.00004 1.33334 4.29852 1.33334 4.66671C1.33334 5.0349 1.63182 5.33337 2.00001 5.33337ZM4.00001 6.00004C4.00001 6.36823 3.70153 6.66671 3.33334 6.66671C2.96515 6.66671 2.66668 6.36823 2.66668 6.00004C2.66668 5.63185 2.96515 5.33337 3.33334 5.33337C3.70153 5.33337 4.00001 5.63185 4.00001 6.00004ZM6.00001 6.66671C6.3682 6.66671 6.66668 6.36823 6.66668 6.00004C6.66668 5.63185 6.3682 5.33337 6.00001 5.33337C5.63182 5.33337 5.33334 5.63185 5.33334 6.00004C5.33334 6.36823 5.63182 6.66671 6.00001 6.66671ZM9.33334 6.00004C9.33334 6.36823 9.03487 6.66671 8.66668 6.66671C8.29849 6.66671 8.00001 6.36823 8.00001 6.00004C8.00001 5.63185 8.29849 5.33337 8.66668 5.33337C9.03487 5.33337 9.33334 5.63185 9.33334 6.00004ZM10 8.00004C10.3682 8.00004 10.6667 7.70156 10.6667 7.33337C10.6667 6.96518 10.3682 6.66671 10 6.66671C9.63182 6.66671 9.33334 6.96518 9.33334 7.33337C9.33334 7.70156 9.63182 8.00004 10 8.00004ZM8.00001 7.33337C8.00001 7.70156 7.70153 8.00004 7.33334 8.00004C6.96515 8.00004 6.66668 7.70156 6.66668 7.33337C6.66668 6.96518 6.96515 6.66671 7.33334 6.66671C7.70153 6.66671 8.00001 6.96518 8.00001 7.33337ZM4.66668 8.00004C5.03487 8.00004 5.33334 7.70156 5.33334 7.33337C5.33334 6.96518 5.03487 6.66671 4.66668 6.66671C4.29849 6.66671 4.00001 6.96518 4.00001 7.33337C4.00001 7.70156 4.29849 8.00004 4.66668 8.00004ZM2.66668 7.33337C2.66668 7.70156 2.3682 8.00004 2.00001 8.00004C1.63182 8.00004 1.33334 7.70156 1.33334 7.33337C1.33334 6.96518 1.63182 6.66671 2.00001 6.66671C2.3682 6.66671 2.66668 6.96518 2.66668 7.33337Z",
    fill: "url(#paint0_linear_142_191)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_142_191",
    x: 1.33334,
    y: 1.33337,
    width: 9.33334,
    height: 7.66663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_142_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_142_191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_191",
    x1: 1.33334,
    y1: 1.33337,
    x2: 1.33334,
    y2: 8.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStatesIcon);
export default __webpack_public_path__ + "static/media/united_states_icon.e5ccd89653beac195e25f4df8fc1d254.svg";
export { ForwardRef as ReactComponent };